'use client';
// ═══════════════════════════════════════════════════════════════════════════
// LA BARRE DES PAGES LÉGALES, DANS LA LANGUE DU LECTEUR
// ───────────────────────────────────────────────────────────────────────────
// 📏 LE DÉFAUT, mesuré le 02/09/2026. Les quatre pages légales portent le
// néerlandais depuis longtemps — `cgu-employe` a 32 clés FR et 32 NL, aucune
// vide. Mais la barre qui les relie, elle, était écrite en dur en français, en
// TÊTE de page. Un lecteur néerlandophone recevait donc « Mentions legales /
// CGV / CGU Employe / Confidentialite » au-dessus d'un texte néerlandais.
//
// ⚠️ ET SES QUATRE LIENS PERDAIENT LA LANGUE : cliquer « CGV » depuis une page
// lue en néerlandais rouvrait le français. Sur 17 liens vers /legal/ dans
// l'app, ZÉRO ne transmettait la langue (mesure du 02/09) — la traduction
// existait partout et ne s'affichait nulle part.
//
// ⚠️ POURQUOI PAS `useSearchParams` : sur une page statique, Next exige alors
// une frontière Suspense, et son absence casse le build. On lit donc
// `window.location.search` en initialisation paresseuse — exactement ce que
// font les quatre pages légales elles-mêmes, donc la barre et la page tombent
// toujours d'accord.
import { useLangueArrivee } from '@/app/lib/use-langue-arrivee';

const T = {
  fr: { mentions: 'Mentions légales', cgv: 'CGV', cguUser: 'CGU', cgu: 'CGU Employé', privacy: 'Confidentialité' },
  nl: { mentions: 'Wettelijke vermeldingen', cgv: 'Algemene voorwaarden', cguUser: 'Gebruiksvoorwaarden', cgu: 'Gebruiksvoorwaarden werknemer', privacy: 'Privacybeleid' },
  en: { mentions: 'Legal notice', cgv: 'Terms', cguUser: 'Terms of use', cgu: 'Employee terms', privacy: 'Privacy' },
  de: { mentions: 'Impressum', cgv: 'AGB', cguUser: 'Nutzungsbedingungen', cgu: 'Nutzungsbedingungen (Mitarbeiter)', privacy: 'Datenschutz' },
};

const LIENS = [
  ['/legal/mentions', 'mentions'],
  ['/legal/cgv', 'cgv'],
  ['/legal/cgu', 'cguUser'],
  ['/legal/cgu-employe', 'cgu'],
  ['/legal/privacy', 'privacy'],
];

export default function NavLegal() {
  const [lang] = useLangueArrivee(Object.keys(T));

  const t = T[lang] || T.fr;
  return (
    <nav style={{ display: 'flex', gap: 20, fontSize: 11, color: '#888', flexWrap: 'wrap' }}>
      {LIENS.map(([href, cle]) => (
        // ⚠️ La langue voyage avec le lien : sans elle, passer d'une page légale
        // à l'autre rebasculait en français à chaque clic.
        <a key={href} href={`${href}?lang=${lang}`} style={{ color: '#888', textDecoration: 'none' }}>
          {t[cle]}
        </a>
      ))}
    </nav>
  );
}
